import { render, staticRenderFns } from "./ResultViewType2.vue?vue&type=template&id=2869de24&scoped=true"
import script from "./ResultViewType2.vue?vue&type=script&lang=js"
export * from "./ResultViewType2.vue?vue&type=script&lang=js"
import style0 from "./ResultViewType2.vue?vue&type=style&index=0&id=2869de24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2869de24",
  null
  
)

export default component.exports